import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
            <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
              © {new Date().getFullYear()} Hamsyl Travel &amp; Tours Ltd
            </span>
            <span className="text-muted d-none d-sm-block">Operations console</span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
